<div class="sc" role="dialog" aria-modal="true" aria-labelledby="scTitle" aria-describedby="scIntro">
  <ng-container *ngIf="state !== 'done'; else doneTpl">
    <form class="sc-form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
      <div class="sc-head">
        <div class="sc-head-body">
          <span class="sc-brand">
            <img class="sc-brand-mark" src="assets/trakr_icon.svg" alt="" />
            <span class="sc-wordmark">trakr</span>
            <span class="sc-brand-sub">{{ 'support.brandSub' | translate }}</span>
          </span>
          <h2 class="sc-title" id="scTitle">{{ 'support.title' | translate }}</h2>
          <p class="sc-intro" id="scIntro">{{ 'support.intro' | translate }}</p>
        </div>
        <button mat-icon-button type="button" class="sc-close" (click)="onClose()" [disabled]="state === 'sending'" [attr.aria-label]="'support.close' | translate">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="sc-body">
        <div class="sc-alert" role="alert" *ngIf="state === 'failed'">
          <mat-icon>error_outline</mat-icon>
          <div>
            <div class="sc-alert-title">{{ 'support.failedTitle' | translate }}</div>
            <div class="sc-alert-text">
              {{ 'support.failedText' | translate }}
              <a class="sc-link" [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>.
            </div>
          </div>
        </div>

        <div class="sc-alert" role="alert" *ngIf="limitHit">
          <mat-icon>error_outline</mat-icon>
          <div class="sc-alert-text">{{ 'support.tooMany' | translate }}</div>
        </div>

        <fieldset class="sc-fields" [disabled]="state === 'sending'">
          <legend class="sc-visually-hidden">{{ 'support.yourMessage' | translate }}</legend>

          <div class="sc-field" *ngIf="noEmail">
            <label class="sc-label" for="scEmail">{{ 'support.replyEmail' | translate }}<span class="sc-req" aria-hidden="true">*</span></label>
            <input id="scEmail" class="sc-input" type="email" formControlName="replyEmail" autocomplete="email" inputmode="email"
              autocapitalize="off" spellcheck="false" placeholder="name@company.com" required aria-required="true"
              [attr.aria-invalid]="errorFor('replyEmail') ? true : null" aria-describedby="scEmailHint scEmailErr" />
            <p class="sc-hint" id="scEmailHint">{{ 'support.noEmailHint' | translate }}</p>
            <p class="sc-error" id="scEmailErr" *ngIf="errorFor('replyEmail') as e">{{ e | translate }}</p>
          </div>

          <div class="sc-field">
            <div class="sc-label-row">
              <label class="sc-label" for="scName">{{ 'support.ticketName' | translate }}<span class="sc-req" aria-hidden="true">*</span></label>
              <span class="sc-count" id="scNameCount" *ngIf="showNameCount" [class.is-over]="nameLen > nameMax">{{ nameLen }} / {{ nameMax }}</span>
            </div>
            <input id="scName" class="sc-input" type="text" formControlName="name" required aria-required="true"
              [placeholder]="'support.ticketNamePlaceholder' | translate"
              [attr.aria-invalid]="errorFor('name') ? true : null" aria-describedby="scNameErr scNameCount" />
            <p class="sc-error" id="scNameErr" *ngIf="errorFor('name') as e">{{ e | translate }}</p>
          </div>

          <div class="sc-field">
            <div class="sc-label-row">
              <label class="sc-label" for="scDesc">{{ 'support.ticketDescription' | translate }}<span class="sc-req" aria-hidden="true">*</span></label>
              <span class="sc-count" id="scDescCount" *ngIf="showDescCount" [class.is-over]="descLen > descMax">{{ descLen }} / {{ descMax }}</span>
            </div>
            <textarea id="scDesc" class="sc-input sc-textarea" rows="8" formControlName="desc" required aria-required="true"
              [placeholder]="'support.ticketDescriptionPlaceholder' | translate"
              [attr.aria-invalid]="errorFor('desc') ? true : null" aria-describedby="scDescErr scDescCount"></textarea>
            <p class="sc-error" id="scDescErr" *ngIf="errorFor('desc') as e">{{ e | translate }}</p>
          </div>
        </fieldset>

        <div class="sc-notes">
          <p class="sc-reply" *ngIf="!noEmail">
            <mat-icon>mail_outline</mat-icon>
            <span>{{ 'support.replyTo' | translate }} <b>{{ accountEmail }}</b></span>
          </p>
          <p class="sc-meta">
            <mat-icon>info_outline</mat-icon>
            <span>{{ 'support.includeInfo' | translate }}</span>
          </p>
        </div>
      </div>

      <div class="sc-foot">
        <button mat-stroked-button type="button" class="sc-btn" (click)="onClose()" [disabled]="state === 'sending'">{{ 'support.cancel' | translate }}</button>
        <button mat-flat-button color="primary" type="submit" class="sc-btn" [attr.aria-busy]="state === 'sending' ? true : null" [disabled]="state === 'sending'">
          <ng-container *ngIf="state === 'sending'"><mat-spinner diameter="18" class="sc-spinner"></mat-spinner>{{ 'support.sending' | translate }}</ng-container>
          <ng-container *ngIf="state === 'failed'"><mat-icon>refresh</mat-icon>{{ 'support.tryAgain' | translate }}</ng-container>
          <ng-container *ngIf="state === 'editing'">{{ 'support.send' | translate }}</ng-container>
        </button>
      </div>
    </form>
  </ng-container>

  <ng-template #doneTpl>
    <div class="sc-head">
      <div class="sc-head-body">
        <span class="sc-brand">
          <img class="sc-brand-mark" src="assets/trakr_icon.svg" alt="" />
          <span class="sc-wordmark">trakr</span>
          <span class="sc-brand-sub">{{ 'support.brandSub' | translate }}</span>
        </span>
      </div>
      <button mat-icon-button type="button" class="sc-close" (click)="onClose()" [attr.aria-label]="'support.close' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="sc-body">
      <div class="sc-done" role="status">
        <span class="sc-done-tile"><mat-icon>check</mat-icon></span>
        <h2 class="sc-title" id="scTitle">{{ 'support.doneTitle' | translate }}</h2>
        <p class="sc-done-text" id="scIntro">{{ 'support.doneText' | translate }} <b>{{ sentEmail }}</b></p>
        <p class="sc-done-ref">{{ 'support.ticket' | translate }} <b>{{ sentName }}</b></p>
      </div>
    </div>
    <div class="sc-foot">
      <button mat-flat-button color="primary" type="button" class="sc-btn" (click)="onClose()">{{ 'support.done' | translate }}</button>
    </div>
  </ng-template>
</div>
